import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getGroups,
    getAllOperationEntitiesForDropDown,
    GetEmployeeDetails,
    GetCollectionPointsFilter,
    saveEmployee,
    updateEmployee,
    SaveEmployeeBiometrics,
    getBiometrics,
    RemoveEmployeeBiometrics,
    GetEmployeeTypesData,
    GetEmployeeCategoriesData,
    GetEmployeeSubCategoriesData,
    GetCollectionPointsByCpCategoryandOpEntity,
    GetEemployeeDesignationsData,
    GetEemployeeByID,
    UpdateEmployeeBiometricIsDefault,
    getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID,
    GetEemployeeJobTypeByID,
    GetAllOperationEntityByGroupID,
    SaveEmployeeSubordinator,
    GetEmployeeSubordinators,
    InActiveEmployeeSubordinator,
    DeleteEmployeeSubordinator,
    getOperationEntitiesByGroupForDropDown
};


async function GetEmployeeDetails(employeeBiometrics) {
    employeeBiometrics.groupID = employeeBiometrics.groupID.toString();
    employeeBiometrics.operationEntityID = employeeBiometrics.operationEntityID.toString();
    const response = await CommonPost('/api/Employee/FilterEmployee', null, employeeBiometrics);
    return response.data;
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/Card/GetCollectionPointsFilter', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id))
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function saveEmployee(employeeInformation) {
    employeeInformation.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    employeeInformation.createdDate = new Date().toISOString();
    const response = await CommonPost('/api/Employee/SaveEmployeeWithJobType', null, employeeInformation);
    return response;
}

async function updateEmployee(employeeInformation) {
    employeeInformation.modifiedBy = parseInt(tokenDecoder.getUserIDFromToken());
    employeeInformation.modifiedDate = new Date().toISOString();
    const response = await CommonPost('/api/Employee/UpdateEmployeeWithJobTypeCreation', null, employeeInformation);
    return response;
}
async function SaveEmployeeBiometrics(pictures, employeeID, isDefault) {
    let employeeBiometrics = {
        employeeID: employeeID,
        employeeBiometricData: pictures,
        employeeBiometricDataTypeID: 1,
        isDefault: isDefault,
        isActive: true,
        CreatedBy: 0,
        CreatedDate: new Date().toISOString(),
        modifiedBy: 0,
        ModifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/EmployeeBiometrics/SaveEmployeeBiometrics', null, employeeBiometrics);
    return response;
}
async function getBiometrics(id, typeId) {
    let filtermodel = {
        employeeID: id,
        employeeBiometricDataTypeID: typeId,

    }
    const response = await CommonPost('/api/EmployeeBiometrics/GetEmployeeBiometricsById', null, filtermodel);

    return response.data;
}
async function RemoveEmployeeBiometrics(id, userId) {
    const response = await CommonGet('/api/EmployeeBiometrics/RemoveEmployeeBiometrics', 'employeeBiometricID=' + id + '&modifiedBy=' + userId);
    return response;
}

async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function GetEmployeeCategoriesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeCategoryEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function GetEmployeeSubCategoriesData(employeeCategoryID) {
    var response = await CommonGet('/api/Employee/GetEmployeeSubCategories', 'employeeCategoryID=' + employeeCategoryID);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointCategoryID"]] = item[1]["collectionPointTypeName"]
    }
    return array;
}

async function GetCollectionPointsByCpCategoryandOpEntity(operationEntityID, collectionPointCategoryID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointsByCpCategoryandOpEntity', 'operationEntityID=' + operationEntityID + '&collectionPointCategoryID=' + collectionPointCategoryID);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function GetEemployeeDesignationsData(employeeCategoryID) {
    var array = [];
    var response = await CommonGet('/api/Employee/GetEmployeeDesignations', 'employeeCategoryID=' + employeeCategoryID);
    for (let item of Object.entries(response.data)) {
        array[item[1]["designationID"]] = item[1]["designationName"];
    }
    return array;
}

async function UpdateEmployeeBiometricIsDefault(oldEmployeeBiometricID, newEmployeeBiometricID) {
    const response =
        await CommonGet('/api/EmployeeBiometrics/UpdateEmployeeBiometricIsDefault', 'oldEmployeeBiometricID=' + oldEmployeeBiometricID + '&newEmployeeBiometricID=' + newEmployeeBiometricID);
    return response;
}

async function GetEemployeeByID(id) {
    var response = await CommonGet('/api/Employee/GetEmployeeByID', 'id=' + id);
    return response.data;
}

async function GetEemployeeJobTypeByID(id) {
    var response = await CommonGet('/api/Employee/GetEemployeeJobTypeByID', 'id=' + id);
    return response.data;
}

async function getAvailableHaverstingJobTypeByCollectionPointIDEmployeeTypeID(collectionPointID, employeeTypeID) {
    var response = await CommonGet('/api/HaverstingJobType/GetHaverstingJobTypeByCollectionPointIDEmployeeTypeID', 'collectionPointID=' + collectionPointID + '&employeeTypeID=' + employeeTypeID);
    return response.data;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/NetOutturn/GetAllEstateByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}
async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function SaveEmployeeSubordinator(model) {
    const response = await CommonPost('/api/EmployeeSubordinator/SaveEmployeeSubordinator', null, model);
    return response;
}

async function GetEmployeeSubordinators(id) {
    const response = await CommonGet('/api/EmployeeSubordinator/GetEmployeeSubordinators', 'employeeID=' + id);
    return response.data;
}

async function InActiveEmployeeSubordinator(model) {
    const response = await CommonPost('/api/EmployeeSubordinator/InActiveEmployeeSubordinator', null, model);
    return response;
}

async function DeleteEmployeeSubordinator(model) {
    const response = await CommonPost('/api/EmployeeSubordinator/DeleteEmployeeSubordinator', null, model);
    return response;
}